import asyncThunk from '@/lib/asyncThunk'

type Request = Record<never, never>

export const deleteSMS = asyncThunk<Request, void>({
  name: 'sms/delete',
  method: 'DELETE',
  uri: '/sms',
})
